import React from "react";

export function FlexibleMeetingsSamHack() {
  return <div className="cw-space-y-8">Add new Flexpage here</div>;
}
